import type { ReactNode } from "react";

export const ModKeysList = [
  "tieredDiscount",
  "cartDiscount",
  "splitUrl",
  "price",
  "theme",
  "template",
  "freeGift",
  "freeShipping",
  "onsiteInjections",
  "onsiteEdits",
  "shipping",
  "shippingProgressBar",
  "priceStayAi",
  "goals",
  "offer",
] as const;

export type ModKeys = (typeof ModKeysList)[number];

export type ModConfig = {
  key: ModKeys;
  condition: boolean;
  component: ReactNode;
};
